export const PLATFORM_LIST = [
{value: "ios", label: "Apple Store (iOS)"},
{value: "android", label: "Google Play (Android)"},
{value: "amazon", label: "Amazon Store (Amazon)"},
{value: "windows", label: "Microsoft Store (Windows)"},
];